module.exports = __webpack_public_path__ + "img/工具大礼包.7a8a9bd5.png";